import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user_id: localStorage.getItem('user_id')
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserId: (state, action) => {
          state.userId = action.payload
          localStorage.setItem('user_id', action.payload)
        },
    },
})

// Action creators are generated for each case reducer function
export const { setUserId } = userSlice.actions

export default userSlice.reducer
